const SAFE_IMAGE_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/avif',
])

interface ViewableFile {
  name: string
  mimeType?: string
}

function isPdf(file: ViewableFile): boolean {
  return file.mimeType === 'application/pdf' || /\.pdf$/i.test(file.name)
}

/** Whether a browser can show this file itself, rather than saving it. */
export function canViewInBrowser(file: ViewableFile): boolean {
  return isPdf(file) || SAFE_IMAGE_TYPES.has(file.mimeType ?? '')
}

/**
 * Stored MIME types come from the uploader's browser, and a blob URL runs on the
 * app's own origin. Forcing the type stops a file labelled text/html or
 * image/svg+xml from running as a page with access to the signed-in session.
 */
export function toViewableBlob(blob: Blob, file: ViewableFile): Blob {
  if (isPdf(file)) return new Blob([blob], { type: 'application/pdf' })
  const type = file.mimeType && SAFE_IMAGE_TYPES.has(file.mimeType) ? file.mimeType : 'application/octet-stream'
  return new Blob([blob], { type })
}
